module.exports = { "default": require("core-js/library/fn/object/get-own-property-names"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/get-own-property-names.js
// module id = 235
// module chunks = 31